import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GetMerchantBusinessProfileService } from '../../services/merchant-get-business-profile.service';
import { RegenerateMerchantKeysService } from '../../services/merchant-regenerate-key.service';

@Component({
  selector: 'app-merchant-profile',
  templateUrl: './merchant-profile.component.html',
  styleUrls: ['./merchant-profile.component.scss']
})
export class MerchantProfileComponent implements OnInit {


  data;
  constructor(
    private auth: AuthService,
    private snackBar: MatSnackBar,
    private getMerchantBusinessProfileService: GetMerchantBusinessProfileService,
    private regenerateMerchantKeysService: RegenerateMerchantKeysService,
    private cdr : ChangeDetectorRef,

  ) { }

  async ngOnInit() {
    let merchantId = await this.auth.getMerchantId()
    this.getMerchantBusinessProfileService.setParams({merchantId:merchantId});
    this.data = await this.getMerchantBusinessProfileService.make();
    this.cdr.detectChanges()
  }

  async regenerateKeys(){
    let merchantId = await this.auth.getMerchantId()
    this.regenerateMerchantKeysService.setParams({merchantId:merchantId});
    let keys = await this.regenerateMerchantKeysService.make();
    this.data.clientId = keys.data.clientId;
    this.data.secretId = keys.data.secretId;
    this.cdr.detectChanges()
  }

  copyToClipboard(text) {
    let message = '';
    try {
      const selBox = document.createElement('textarea') as HTMLTextAreaElement;
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '';
      selBox.style.opacity = '0';
      selBox.value = text;
      document.body.appendChild(selBox);
      selBox.select();
      const success = document.execCommand('copy');
      document.body.removeChild(selBox);
      message = success ? 'key copied to clipboard' : 'Unable to copy the key';
    } catch (err) {
      message = 'Unable to copy the key';
    } finally {
      this.snackBar.open(message, null, { duration: 2000 });
    }
  }

}
